import React from "react";
import { Typography } from "material-ui";
import { Grid } from "material-ui";
import TileIcon from "./TileIcon";
import CarImage from "./../../../images/auto_detenido.svg";

const fakeData = {
  Reportando: 5,
  Fallando: 3,
  Neutral: 1
};

const UnitsStatusTile = props => {
  const { data, lang } = props;
  const unitsStatus = {
    Reportando: data.EstatusUnidades.filter(s => s.Estatus === "OK").length,
    Neutral: data.EstatusUnidades.filter(
      s => s.Estatus === "NEUTRAL" || s.Estatus === "NEUTRAL 2"
    ).length,
    Fallando: data.EstatusUnidades.filter(
      s => s.Estatus === "FALLANDO" || s.Estatus === "REVISION NECESARIA"
    ).length
  };

  return (
    <div className="dashboard-tile">
      <TileIcon color="#f38a21" image={CarImage} />
      <div className="tile-header">{lang.EstadoDeConectividad}</div>

      <Grid className="tile-body-divided" container>
        <Grid className="subbody-1" item xl={4} lg={4} md={4} sm={4} xs={4}>
          <Typography
            variant="display3"
            align="center"
            color="textSecondary"
            className="area"
          >
            {unitsStatus.Reportando}
          </Typography>

          <span className="title-reportando">{lang.Activas}</span>
          <div>
            <span className="tile-descriptor-text">{` < 30 min.`}</span>
          </div>
        </Grid>
        <Grid className="subbody-2" item xl={4} lg={4} md={4} sm={4} xs={4}>
          <Typography
            variant="display3"
            align="center"
            color="textSecondary"
            className="headline"
          >
            {unitsStatus.Neutral}
          </Typography>
          <span className="title-neutral">{lang.Neutral}</span>
          <div>
            <span className="tile-descriptor-text">{` > 30 min.`}</span>
          </div>
        </Grid>
        <Grid className="subbody-3" item xl={4} lg={4} md={4} sm={4} xs={4}>
          <Typography
            variant="display3"
            align="center"
            color="textSecondary"
            className="headline"
          >
            {unitsStatus.Fallando}
          </Typography>
          <span className="title-fallando">{lang.Inactivas}</span>
          <div>
            <span className="tile-descriptor-text">{` > 24 hrs.`}</span>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default UnitsStatusTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/UnitsStatusTile.js